import { SectionComponentProps } from "../../types";
import commercialInfoRef from "../references/commercial-information.png";
import Reference from "../../common/Reference";
import Section from "../../common/Section/Section";
import {
  buildMinimumOrderField,
  buildUnitOfSaleField,
} from "../../../fields/commercialInformation";

function CommercialInformation({ details, onEdit }: SectionComponentProps) {
  const { commercialInformation, outcomes } = details;

  return (
    <Section
      title="Commercial information"
      columns={2}
      fields={[
        buildUnitOfSaleField(outcomes, 0),
        buildMinimumOrderField(commercialInformation, 1),
      ]}
      onEdit={() => onEdit("commercial-information")}
      reference={[
        {
          type: "image",
          place: "beneath",
          index: 0,
          item: (
            <Reference
              image={commercialInfoRef}
              radius="25px"
              alt="Commercial information reference"
              testId="commercial-information-reference"
            />
          ),
        },
      ]}
    />
  );
}

export default CommercialInformation;
